(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    // Listen for slideshow:select events to update swipe indicator dots
document.addEventListener('slideshow:select', (event) => {
  const slideshow = event.target;
  const productCard = slideshow.closest('product-card');
  if (!productCard) return;
  
  const dotsContainer = productCard.querySelector('.product-card__swipe-dots');
  if (!dotsContainer) return;
  
  const dots = dotsContainer.querySelectorAll('.product-card__swipe-dot:not(.product-card__swipe-dot--more)');
  const activeIndex = event.detail?.index ?? 0;
  
  dots.forEach((dot, i) => {
    dot.classList.toggle('product-card__swipe-dot--active', i === activeIndex);
  });
});
  } catch(e) { console.error(e); }
})();

})();
